import React from "react";
import "./AccountCard.css";
import { useAccountDetails } from "../../context/AccountDetailsContext/AccountDetailsProvider";
import { highlightMatches } from "../../util/styleUtils";
import { FaUser } from "react-icons/fa";

const CardTitle = ({ children }) => {
  return (
    <div
      className="text-kit-lg mb-kit-4 [&>*]:font-['Primary-Medium'] max-w-full leading-[1.9rem] flex justify-between"
      style={{
        color: "var(--inyc-primary-text-color)",
        display: "-webkit-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: 2,
        overflow: "hidden",
      }}
    >
      {children}
    </div>
  );
};

const AccountCard = ({
  data,
  disabled,
  className = "default-event-container",
  onClick,
}) => {
  const { selectAccount } = useAccountDetails();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      selectAccount(data);
    }
  };

  const displayName = data.businessName || `${data.firstName || ""} ${data.lastName || ""}`.trim() || data.username;
  const avatarUrl = data.profilePicture || `https://ui-avatars.com/api/?name=${encodeURIComponent(displayName)}&background=random`;


  return (
    <div
      className={`relative md:max-w-[600px] ${disabled ? "opacity-[0.4]" : ""}`}
    >
      <div
        className={`event-container ${className}`}
        onClick={handleClick}
      >
        <div className="flex w-full mb-kit-8 justify-between overflow-hidden max-w-full items-stretch gap-kit-8">
          <div className="flex items-center gap-kit-12 min-w-0">
            <div className="w-[3.5rem] h-[3.5rem] rounded-kit-full bg-[--inyc-primary-light] flex items-center justify-center overflow-hidden border border-[--inyc-primary-light]">
              {data.profilePicture ? (
                <img
                  src={avatarUrl}
                  alt={displayName}
                  className="w-full h-full object-cover"
                  style={{ minWidth: 0, minHeight: 0 }}
                />
              ) : (
                <FaUser size={24} color="var(--inyc-primary-color)" />
              )}
            </div>
            <div className="flex flex-col min-w-0">
              <span className="font-['Primary-Medium'] text-kit-md truncate" style={{ color: "var(--inyc-primary-text-color)" }}>
                {displayName}
              </span>
              <span className="text-kit-sm text-[--inyc-secondary] truncate">@{data.username}</span>
            </div>
          </div>
          {(data.accountType === 'business' || data.accountType === 'artist') && <div className="flex-shrink-0 flex items-center justify-center font-['Primary-Regular'] whitespace-nowrap px-kit-12 py-kit-4 text-kit-sm rounded-kit-xs bg-[--inyc-primary-light] text-[--inyc-secondary]">
            <span className="text-kit-sm">{data.accountType}</span>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default AccountCard; 